"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENTTYPE = exports.INTERACTION = exports.TASK = exports.SETTINGS = exports.SESSION = exports.VIEWER = exports.SCENE = exports.RENDERING = exports.CAMERA = void 0;
var CAMERA;
(function (CAMERA) {
    CAMERA["CAMERA_START"] = "camera.start";
    CAMERA["CAMERA_MOVE"] = "camera.move";
    CAMERA["CAMERA_END"] = "camera.end";
})(CAMERA = exports.CAMERA || (exports.CAMERA = {}));
var RENDERING;
(function (RENDERING) {
    RENDERING["BEAUTY_RENDERING_FINISHED"] = "rendering.beautyRenderingFinished";
})(RENDERING = exports.RENDERING || (exports.RENDERING = {}));
var SCENE;
(function (SCENE) {
    SCENE["SCENE_BOUNDING_BOX_CHANGE"] = "scene.boundingBoxChange";
})(SCENE = exports.SCENE || (exports.SCENE = {}));
var VIEWER;
(function (VIEWER) {
    VIEWER["BUSY_MODE_ON"] = "viewer.busy.on";
    VIEWER["BUSY_MODE_OFF"] = "viewer.busy.off";
    VIEWER["VIEWER_CREATED"] = "viewer.created";
    VIEWER["VIEWER_UPDATED"] = "viewer.updated";
    VIEWER["VIEWER_CLOSED"] = "viewer.closed";
})(VIEWER = exports.VIEWER || (exports.VIEWER = {}));
var SESSION;
(function (SESSION) {
    SESSION["SESSION_CREATED"] = "session.created";
    SESSION["SESSION_CUSTOMIZED"] = "session.customized";
    SESSION["SESSION_CLOSED"] = "session.closed";
    SESSION["SESSION_INITIAL_OUTPUTS_LOADED"] = "session.initialOutputsLoaded";
})(SESSION = exports.SESSION || (exports.SESSION = {}));
var SETTINGS;
(function (SETTINGS) {
    SETTINGS["SETTINGS_UPDATE"] = "settings.update";
})(SETTINGS = exports.SETTINGS || (exports.SETTINGS = {}));
var TASK;
(function (TASK) {
    TASK["TASK_START"] = "task.start";
    TASK["TASK_PROCESS"] = "task.process";
    TASK["TASK_END"] = "task.end";
    TASK["TASK_CANCEL"] = "task.cancel";
})(TASK = exports.TASK || (exports.TASK = {}));
var INTERACTION;
(function (INTERACTION) {
    INTERACTION["DRAG_START"] = "interaction.drag.start";
    INTERACTION["DRAG_MOVE"] = "interaction.drag.move";
    INTERACTION["DRAG_END"] = "interaction.drag.end";
    INTERACTION["HOVER_ON"] = "interaction.hover.on";
    INTERACTION["HOVER_OFF"] = "interaction.hover.off";
    INTERACTION["SELECT_ON"] = "interaction.select.on";
    INTERACTION["SELECT_OFF"] = "interaction.select.off";
})(INTERACTION = exports.INTERACTION || (exports.INTERACTION = {}));
// export 
//     available
//     registered
//     registeredBatch
//     update
//     status
// parameters 
//     registered
//     registeredBatch
//     update
//     value_update
// state 
//     BUSY
//     IDLE
//     MESSAGE
//     FAILED
// VIEWER
//     FRAMERATE
//     RENDER_INFO
//     RENDER_BEAUTY_START
//     RENDER_BEAUTY_CANCEL
//     RENDER_BEAUTY_END
//     VISIBILITY_ON
//     VISIBILITY_OFF
// INTERACTION
//     DRAG_START
//     DRAG_MOVE
//     DRAG_END
//     HOVER_ON
//     HOVER_OVER
//     HOVER_OFF	
//     SELECT_ON
//     SELECT_OFF
exports.EVENTTYPE = {
    CAMERA,
    RENDERING,
    SCENE,
    SESSION,
    SETTINGS,
    VIEWER,
    INTERACTION,
    TASK
};
//# sourceMappingURL=EventTypes.js.map